import script from "./EtapaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EtapaCard.vue?vue&type=script&setup=true&lang=js"

import "./EtapaCard.vue?vue&type=style&index=0&id=f8a319d2&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8a319d2"]])

export default __exports__